import React from 'react';

import styled from 'styled-components';
import { COLOURS, BREAK_POINTS } from '../../consts/style';
import { Heading } from '../Common/Headings';
import TrustPilotLogo from './TrustPilotLogo';

import starImages from './starImages';
import { TARGET_BLANK } from '../../consts/config';
import { TRUSTPILOT_PREFIX } from '../../consts/tracking';

const StarsText = styled(Heading)`
  color: ${COLOURS.NEUTRALS.DARK};
  margin: 16px 0;
`;

const ScoreTextContainer = styled.div`
  padding-bottom: 24px;
  @media screen and (min-width: ${BREAK_POINTS.Min.LG}) {
    padding-bottom: 32px;
  }

  font-size: 14px;
  font-weight: 400;
  line-height: 24px;
  max-width: 80%;
  margin: 0 auto;

  justify-content: center;

  display: flex;
  flex-wrap: wrap;
  gap: 16px;

  & > div {
    margin: auto 0;
  }
`;
const ScoreTextHeading = styled.span`
  color: ${COLOURS.NEUTRALS.DEFAULT};
  font-weight: 600;
`;

const ScoreTextDivider = styled.span`
  color: ${COLOURS.NEUTRALS.DEFAULT};
`;

const ScoreTextSubText = styled.span`
  color: ${COLOURS.NEUTRALS.DEFAULT};
`;

const TrustPilotLogoContainer = styled.div`
  box-sizing: border-box;
  height: 30px;
  padding-bottom: 6px;

  @media screen and (min-width: ${BREAK_POINTS.Min.MD}) {
    text-align: left;
  }
`;

const Container = styled.div`
  text-align: center;

  a {
    text-decoration: none;
  }
`;

export const toReviewsNumDisplayText = (no: number) => {
  // Hello future traveller ... looking to format the review numbers?
  // Behold:

  //   const { floor, log10 } = Math;
  //   const noOfZeros = floor(log10(no));
  //   const head = floor(no / 10 ** noOfZeros);

  //   let displayText = `+${head * 10 ** (noOfZeros % 3)}`;
  //   if (noOfZeros < 3) return no.toString();
  //   else if (noOfZeros < 6) displayText += 'K';
  //   else if (noOfZeros < 9) displayText += 'M';
  //   else if (noOfZeros < 12) displayText += 'B';
  //   else displayText += 'T';

  return no.toLocaleString();
};

export type Props = {
  numberOfReviews: number;
  starsImageUrl: string;
  starsString: string;
  trustScore: number;
  starsValue: number;
};

export const Summary = ({ starsValue, starsString, trustScore, numberOfReviews }: Props) => {
  const StarsImg = styled(starImages[starsValue.toPrecision(2)])`
    height: 24px;
    width: 100%;

    @media screen and (min-width: ${BREAK_POINTS.Min.MD}) {
      height: 32px;
    }
  `;

  return (
    <Container>
      <a
        href="https://au.trustpilot.com/review/www.originenergy.com.au"
        {...TARGET_BLANK}
        data-id={`${TRUSTPILOT_PREFIX}-summary`}
      >
        <StarsImg />
        <StarsText heading={starsString} tag="p" variant="large" />
        <ScoreTextContainer>
          <div>
            <ScoreTextHeading>TrustScore {trustScore}</ScoreTextHeading>
            <ScoreTextDivider> • </ScoreTextDivider>
            <ScoreTextSubText>
              From over {toReviewsNumDisplayText(numberOfReviews)} reviews, here are some
              favourites.
            </ScoreTextSubText>
          </div>
          <TrustPilotLogoContainer>
            <TrustPilotLogo height="100%" />
          </TrustPilotLogoContainer>
        </ScoreTextContainer>
      </a>
    </Container>
  );
};
